import {
  NgModule,
} from '@angular/core';
import {
  RulesEngineRunnerModule,
} from '@o3r/rules-engine';
import {
  AppPreferencesFactsService,
} from './app-preferences.facts.service';

@NgModule({
  imports: [
    RulesEngineRunnerModule
  ],
  providers: [
    AppPreferencesFactsService
  ]
})
export class AppPreferencesFactsModule {}
